export default "<p>\n  test-report works!\n</p>\n"